// extracted by mini-css-extract-plugin
export var addButton = "_di-4";
export var contentBlockImage = "_di-i";
export var contentBlockWidgetPreview = "_di-g";
export var fulfillmentCutoffWidgetPreview = "_di-9";
export var imageBackdrop = "_di-6";
export var imageIcon = "_di-8";
export var lowProfileImageContainer = "_di-b";
export var lowProfileImageIcon = "_di-f";
export var lowProfileImageIconContainer = "_di-e";
export var lowProfileImagePlaceholder = "_di-d";
export var lowProfileProductImage = "_di-c";
export var lowProfileProductUpsellWidgetPreview = "_di-a";
export var productCard = "_di-5";
export var productImage = "_di-7";
export var productReviewsWidgetPreview = "_di-h";
export var progressBar = "_di-1";
export var progressBarFill = "_di-2";
export var progressBarTrack = "_di-3";
export var shippingOptionWidgetPreview = "_di-j";
export var shippingUpsellProgressBar = "_di-k";
export var thresholdUpsellWidgetPreview = "_di-0";